export default __webpack_public_path__ + "static/media/termsOfUseProvider.54ed5ce2.pdf";